
export const MODAL_MODES = {
  CREATE: 'create',
  UPDATE: 'update',
  VIEW: 'view',
};

export const API_RESPONSE_OK = 'OK';

export function isApiOk(response) {
  return response?.apiresponse?.type === API_RESPONSE_OK;
}

export const TABLE_HEADER_THEME = {
  headerBg: '#F0F0F0',
  headerBorderRadius: 18,
};

export const CONFIRM_MODAL_PROPS = {
  centered: true,
  width: 420,
  okText: 'Delete',
  okType: 'danger',
  cancelText: 'Cancel',
};

export const UNSAVED_CHANGES_CONFIRM_Z_INDEX = 12000;

export const UNSAVED_CHANGES_CONFIRM_PROPS = {
  centered: true,
  width: 420,
  title: 'Discard unsaved changes?',
  content: 'You have unsaved changes. If you close now, those changes will be lost.',
  okText: 'Discard',
  okType: 'danger',
  cancelText: 'Keep editing',
  zIndex: UNSAVED_CHANGES_CONFIRM_Z_INDEX,
};

export const BRAND_PRIMARY_COLOR = '#0c4e8d';

export const COLOR_PICKER_PRESETS = [
  {
    label: 'Recommended',
    defaultOpen: true,
    colors: [
      BRAND_PRIMARY_COLOR,
      '#1677ff',
      '#13c2c2',
      '#52c41a',
      '#faad14',
      '#f7941e',
      '#f5222d',
      '#eb2f96',
      '#722ed1',
      '#000000',
      '#434343',
      '#8c8c8c',
      '#bfbfbf',
      '#ffffff',
      '#fff1f0',
      '#fff7e6',
      '#feffe6',
      '#f6ffed',
      '#e6f4ff',
      '#f9f0ff',
    ],
  },
];

export const MOBILE_NAV_MAX_WIDTH_PX = 768;
export const MOBILE_NAV_MEDIA_QUERY = `(max-width: ${MOBILE_NAV_MAX_WIDTH_PX}px)`;

export const SKELETON_TABLE_ROWS = 8;
export const SKELETON_CARD_COUNT = 6;
export const SKELETON_GRID_CARD_COUNT = 6;
export const SKELETON_FORM_FIELDS = 6;
export const SKELETON_CHIP_COUNT = 8;

export const PAGINATED_SELECT_LOADING_OPTION_VALUE = '__paginated_select_loading__';
